module.exports = __webpack_public_path__ + "img/shenfenzhengzhengmian.b1c8bdea.svg";